import { createTheme } from '@mui/material/styles';

const sambaTheme = createTheme({
  palette: {
    primary: {
      main: '#00adef', // Samba blue
      contrastText: '#fff',
    },
    secondary: {
      main: '#8dc63f', // Samba green
      contrastText: '#fff',
    },
    warning: {
      main: '#ff9800', // Samba orange
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    text: {
      primary: '#003366',
      secondary: '#00adef',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Open Sans',
      'Arial',
      'sans-serif',
    ].join(','),
    h5: {
      fontWeight: 800,
      color: '#003366',
    },
    h6: {
      fontWeight: 700,
      color: '#003366',
    },
    body1: {
      color: '#003366',
    },
    body2: {
      color: '#003366',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 700,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default sambaTheme; 